<template>
    <div>
        <div class="com-page-title">
            <div class="inner">{{ $route.meta.title }}</div>
        </div>
        <div class="com-card">
            <div class="com-card-title">参加者信息</div>
            <div class="com-card-content">
                <div class="com-form-wrap">
                    <van-form class="com-form-vertical" ref="form">
                        <van-field
                            v-model="form.name"
                            :border="false"
                            label="参加人姓名"
                            placeholder="示例：XXX"
                            :rules="[{ required: true, trigger: 'onBlur', message: '请填写参加人姓名' }]"
                        >
                            <template #left-icon>限一人，多人请分开报名</template>
                        </van-field>
                        <van-field
                            v-model="form.mobile"
                            :border="false"
                            label="联系方式"
                            placeholder="请填写手机号码"
                            :rules="[{ required: true, trigger: 'onBlur', message: '请填写手机号码' }, { validator: $validate.phone, message: '手机号格式不正确' }]"
                        />
                        <!-- <van-field
                            class="no-input"
                            :border="false"
                            label="是否添加寺院微信号(接收通知)"
                        >
                            <template #input>
                                <van-radio-group v-model="form.notice" direction="horizontal">
                                <van-radio name="1" shape="square">是</van-radio>
                                <van-radio name="2" shape="square">否</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field> -->
                    </van-form>
                </div>
            </div>
        </div>
        <div class="com-card">
            <div class="com-card-title">供灯功德</div>
            <div class="com-card-content">
                <div class="com-form-wrap">
                    <van-form class="com-form-wrap">
                        <van-field
                            class="no-input"
                            :border="false"
                            label="是否供灯"
                        >
                            <template #input>
                                <van-radio-group v-model="form.light" direction="horizontal">
                                <van-radio :name="true" shape="square">是</van-radio>
                                <van-radio :name="false" shape="square">否</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>
                        <van-field label="供灯数量" colon v-if="form.light">
                            <template #input>
                                <van-stepper v-model="form.goodsNum" />
                            </template>
                        </van-field>
                    </van-form>
                </div>
            </div>
        </div>
        <div class="com-card">
            <div class="com-card-title">详情</div>
            <div class="com-card-content">
                <div class="text-wrap">
                    <p>传灯祈福法会 - 供灯</p>
                    <p v-if="form.light">¥{{ payload.price }} x {{ form.goodsNum }}</p>
                    <p v-else>¥0</p>
                </div>
            </div>
        </div>
        <div class="com-card">
            <div class="com-card-title">合计</div>
            <div class="com-card-content">
                <div class="text-wrap">
                    <p class="t2">¥{{ form.light ? (payload.price * form.goodsNum) : 0 }}</p>
                </div>
                <div class="com-form-submit">
                    <DefaultBtn @click="onPay">支付/报名</DefaultBtn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const form = {
        name: null,
        mobile: null,
        addWechat: 0,
        goodsNum: 1,
        light: true
    }
    export default {
        props: {
            pageData: Object,
            pay: {
                type: Function
            }
        },
        data () {
            return {
                form: { ...form },
                payload: this.pageData
            }
        },
        methods: {
            onPay () {
                // 表单验证
                this.$refs.form.validate().then(err => {
                    if (!err) {
                        const form = {
                            liveList: [this.form],
                            // 法会订单
                            type: 1,
                            // 后台管理订单详情里面后到
                            orderType: JSON.stringify({
                                key: 'fawu-fahui-baoming',
                                pId: this.payload.pId
                            }),
                            // 商品id
                            categoryId: this.payload.id,
                            // 商品id
                            goodsId: this.payload.goodId,
                            // 支付类型
                            payWay: 'JSAPI',
                            orderPrice: this.payload.price * this.form.goodsNum,
                            // orderPrice: 0.01,
                            // 数量为表示免费
                            goodsNum: this.form.light ? this.form.goodsNum : 0
                        }
                        this.pay(form)
                    } else {
                    }
                }).catch(() => {
                    this.$toast('请填写登记信息')
                })
            }
        }
    }
</script>

<style>

</style>